// extracted by mini-css-extract-plugin
export default {"loading":"speakLoading_loading__MfzZ3","item":"speakLoading_item__WMd3B","scale":"speakLoading_scale__xdNcv"};